var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.it.tipoOblea == 1 && !_vm.mobileView,
              expression: "it.tipoOblea == 1 && !mobileView"
            }
          ],
          staticStyle: { height: "90px" },
          attrs: { id: "oblea" }
        },
        [
          _c("div", { attrs: { id: "s1" } }, [
            _c("img", {
              staticStyle: {
                width: "90%",
                height: "90%",
                "object-fit": "contain"
              },
              attrs: { src: _vm.imagenProducto }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                width: "25%",
                height: "100%",
                display: "flex",
                "flex-direction": "column",
                "justify-content": "center",
                "align-items": "flex-start",
                "padding-left": "10px"
              },
              attrs: { title: _vm.item.producto }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.item.esPromo,
                      expression: "item.esPromo"
                    }
                  ],
                  staticClass: "fh lc"
                },
                [
                  _c("img", {
                    staticStyle: { width: "27px" },
                    attrs: { src: "/dist/icon_promo.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { id: "titulo" }
                },
                [_vm._v(_vm._s(_vm.item.producto))]
              ),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "label" }, [_vm._v("Precio:")]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.precio)))
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "s3" } }, [
            _c("div", { attrs: { id: "cc" } }, [
              _c("span", { attrs: { id: "label-cantidad" } }, [
                _vm._v("Cantidad")
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.it.cantidad,
                    expression: "it.cantidad"
                  }
                ],
                staticClass: "cantidad",
                class: { cantidadInv: _vm.cantInvalida },
                attrs: { type: "text" },
                domProps: { value: _vm.it.cantidad },
                on: {
                  keyup: _vm.updateCantidad,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.it, "cantidad", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    "margin-top": "5px",
                    "font-size": "8px",
                    color: "#5C666F",
                    "margin-right": "5px"
                  }
                },
                [_vm._v(_vm._s(_vm.labelUnidades))]
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showLimiteMaximo,
                    expression: "showLimiteMaximo"
                  }
                ],
                class: {
                  itemMaximoPorcentaje: !_vm.cantInvalida,
                  itemMaximoPorcentajeInv: _vm.cantInvalida
                },
                staticStyle: { "margin-top": "4px" }
              },
              [_vm._v(_vm._s(_vm.maxUnidades))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMinUnidades,
                    expression: "showMinUnidades"
                  }
                ],
                class: {
                  itemMaximoPorcentaje: !_vm.cantInvalida,
                  itemMaximoPorcentajeInv: _vm.cantInvalida
                },
                staticStyle: { "margin-top": "4px" }
              },
              [_vm._v(_vm._s(_vm.minUnidades))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showUnidadesDeVenta,
                    expression: "showUnidadesDeVenta"
                  }
                ],
                class: {
                  itemMaximoPorcentaje: _vm.esMultiploValido,
                  itemMaximoPorcentajeInv: !_vm.esMultiploValido
                },
                staticStyle: { "margin-top": "4px" }
              },
              [
                _vm._v(
                  "(Packs de " + _vm._s(_vm.it.unidadesPorPedido) + " unidades)"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.esMultiploValido,
                    expression: "!esMultiploValido"
                  }
                ],
                staticClass: "itemMaximoPorcentajeInv",
                staticStyle: { "margin-top": "4px" }
              },
              [_vm._v(_vm._s(_vm.valorCercano))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showDescuentos,
                    expression: "showDescuentos"
                  }
                ],
                staticStyle: { "margin-top": "10px" },
                attrs: { id: "cc" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: { "margin-top": "5px" },
                    attrs: { id: "label-cantidad" }
                  },
                  [_vm._v("Descuento")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.it.porcentajeDescuento,
                      expression: "it.porcentajeDescuento"
                    }
                  ],
                  staticClass: "cantidad",
                  class: { cantidadInv: _vm.porcentInvalido },
                  attrs: { type: "text" },
                  domProps: { value: _vm.it.porcentajeDescuento },
                  on: {
                    keyup: _vm.updatePorcentaje,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.it,
                        "porcentajeDescuento",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "8px",
                      color: "#5C666F",
                      "margin-right": "16px"
                    }
                  },
                  [_vm._v("%")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showDescuentos,
                    expression: "showDescuentos"
                  }
                ],
                class: {
                  itemMaximoPorcentaje: !_vm.porcentInvalido,
                  itemMaximoPorcentajeInv: _vm.porcentInvalido
                },
                staticStyle: { "margin-top": "4px" }
              },
              [_vm._v(_vm._s(_vm.maximoDescuento))]
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s4" } }, [
            _c("img", {
              staticStyle: { width: "20px", height: "20px" },
              attrs: { id: "btnEliminarItem", src: "/dist/icon-delete.png" },
              on: { click: _vm.btnEliminarItem }
            })
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "s3" } }, [
            _c("div", { staticStyle: { "margin-top": "5px" } }, [
              _c("span", { staticClass: "label" }, [_vm._v("Subtotal:")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "value",
                  staticStyle: {
                    width: "90px",
                    "text-align": "right",
                    "padding-right": "5px"
                  }
                },
                [_vm._v("$" + _vm._s(_vm._f("formatMoney")(_vm.subtotal)))]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.it.tipoOblea == 2 && !_vm.mobileView,
              expression: "it.tipoOblea == 2 && !mobileView"
            }
          ],
          attrs: { id: "oblea-desc" }
        },
        [
          _c("div", { attrs: { id: "s1" } }),
          _vm._v(" "),
          _c("div", { staticStyle: { width: "73%" }, attrs: { id: "s2" } }, [
            _c("span", { attrs: { id: "titulo" } }, [
              _vm._v(_vm._s(_vm.item.producto))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { width: "15%" }, attrs: { id: "s3" } }, [
            _c(
              "div",
              {
                staticClass: "fh lc",
                staticStyle: {
                  "font-size": "12px",
                  color: "#656E76",
                  "margin-right": "5px"
                }
              },
              [
                _vm._v(
                  "\n                 $" +
                    _vm._s(_vm._f("formatMoney")(_vm.item.precio)) +
                    "\n            "
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.it.tipoOblea == 1 && _vm.mobileView,
              expression: "it.tipoOblea == 1  && mobileView"
            }
          ],
          staticClass: "fv ct",
          staticStyle: {
            "margin-bottom": "20px",
            width: "90vw",
            "border-style": "solid",
            "border-width": "1px",
            "border-color": "#dddddd",
            "border-radius": "10px",
            "box-shadow": "2px 2px 4px #dddddd",
            "-webkit-box-shadow": "2px 2px 4px #dddddd",
            "-moz-box-shadow": "2px 2px 4px #dddddd"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "fh rc",
              staticStyle: {
                width: "100%",
                "margin-right": "15px",
                "margin-top": "10px"
              }
            },
            [
              _c("img", {
                staticStyle: { width: "20px", height: "20px" },
                attrs: { id: "btnEliminarItem", src: "/dist/icon-delete.png" },
                on: { click: _vm.btnEliminarItem }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fh cc",
              staticStyle: { width: "100%", height: "114px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fv cc",
                  staticStyle: { width: "40%", height: "100%" }
                },
                [
                  _c("img", {
                    staticStyle: { width: "80%" },
                    attrs: { src: _vm.imagenProducto }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fv cc",
                  staticStyle: { width: "60%", height: "100%" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.item.esPromo,
                          expression: "item.esPromo"
                        }
                      ],
                      staticClass: "fh cc"
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "33px" },
                        attrs: { src: "/dist/icon_promo.png" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "font-size": "14px",
                        "font-weight": "800",
                        color: "#5C666F",
                        "text-align": "center"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.item.producto) + " ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "font-size": "15px",
                        "font-weight": "500",
                        "margin-top": "15px",
                        color: "#5C666F"
                      }
                    },
                    [
                      _vm._v(
                        " Precio: $" + _vm._s(_vm._f("formatMoney")(_vm.precio))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "500",
                        "margin-top": "10px",
                        color: "#5C666F"
                      }
                    },
                    [
                      _vm._v(
                        " Subtotal: $" +
                          _vm._s(_vm._f("formatMoney")(_vm.subtotal))
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fh lc",
              staticStyle: { width: "100%", "margin-top": "15px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fh rc",
                  staticStyle: { width: "50%", height: "100%" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "500",
                        color: "#5C666F"
                      }
                    },
                    [_vm._v("Cantidad")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.it.cantidad,
                        expression: "it.cantidad"
                      }
                    ],
                    staticClass: "cantidad",
                    class: { cantidadInv: _vm.cantInvalida },
                    attrs: { type: "text" },
                    domProps: { value: _vm.it.cantidad },
                    on: {
                      keyup: _vm.updateCantidad,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.it, "cantidad", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh cc",
                      staticStyle: {
                        "font-size": "10px",
                        color: "#5C666F",
                        width: "30px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.labelUnidades))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fv cc",
                  staticStyle: { width: "50%", height: "100%" }
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showLimiteMaximo,
                          expression: "showLimiteMaximo"
                        }
                      ],
                      class: {
                        itemMaximoPorcentaje: !_vm.cantInvalida,
                        itemMaximoPorcentajeInv: _vm.cantInvalida
                      }
                    },
                    [_vm._v(_vm._s(_vm.maxUnidades))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showMinUnidades,
                          expression: "showMinUnidades"
                        }
                      ],
                      class: {
                        itemMaximoPorcentaje: !_vm.cantInvalida,
                        itemMaximoPorcentajeInv: _vm.cantInvalida
                      }
                    },
                    [_vm._v(_vm._s(_vm.minUnidades))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showUnidadesDeVenta,
                          expression: "showUnidadesDeVenta"
                        }
                      ],
                      class: {
                        itemMaximoPorcentaje: _vm.esMultiploValido,
                        itemMaximoPorcentajeInv: !_vm.esMultiploValido
                      }
                    },
                    [
                      _vm._v(
                        "(Packs de " +
                          _vm._s(_vm.it.unidadesPorPedido) +
                          " unidades)"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.esMultiploValido,
                          expression: "!esMultiploValido"
                        }
                      ],
                      staticClass: "itemMaximoPorcentajeInv"
                    },
                    [_vm._v(_vm._s(_vm.valorCercano))]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fh lc",
              staticStyle: { width: "100%", height: "40px" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDescuentos,
                      expression: "showDescuentos"
                    }
                  ],
                  staticClass: "fh rc",
                  staticStyle: { width: "50%", height: "100%" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "500",
                        color: "#5C666F"
                      }
                    },
                    [_vm._v("Descuento")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.it.porcentajeDescuento,
                        expression: "it.porcentajeDescuento"
                      }
                    ],
                    staticClass: "cantidad",
                    class: { cantidadInv: _vm.porcentInvalido },
                    attrs: { type: "text" },
                    domProps: { value: _vm.it.porcentajeDescuento },
                    on: {
                      keyup: _vm.updatePorcentaje,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.it,
                          "porcentajeDescuento",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh cc",
                      staticStyle: {
                        "font-size": "10px",
                        color: "#5C666F",
                        width: "30px"
                      }
                    },
                    [_vm._v("%")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fv cc",
                  staticStyle: { width: "50%", height: "100%" }
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showDescuentos,
                          expression: "showDescuentos"
                        }
                      ],
                      class: {
                        itemMaximoPorcentaje: !_vm.porcentInvalido,
                        itemMaximoPorcentajeInv: _vm.porcentInvalido
                      }
                    },
                    [_vm._v(_vm._s(_vm.maximoDescuento))]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.it.tipoOblea == 2 && _vm.mobileView,
              expression: "it.tipoOblea == 2 && mobileView"
            }
          ],
          staticClass: "fh lc",
          staticStyle: {
            width: "90vw",
            height: "30px",
            "margin-top": "10px",
            "margin-bottom": "5px",
            "background-color": "#ffffaa",
            "border-style": "solid",
            "border-width": "1px",
            "border-color": "#dddddd",
            "border-radius": "10px",
            "box-shadow": "1px 1px 3px #dddddd"
          }
        },
        [
          _c("div", { staticClass: "fh cc", staticStyle: { width: "50%" } }, [
            _c("span", { attrs: { id: "titulo" } }, [
              _vm._v(_vm._s(_vm.item.producto))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fh cc", staticStyle: { width: "50%" } }, [
            _c("span", { staticClass: "label-desc" }, [_vm._v("Descuento:")]),
            _vm._v(" "),
            _c("span", { staticClass: "value" }, [
              _vm._v(" $" + _vm._s(_vm._f("formatMoney")(_vm.item.precio)))
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4269713c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4269713c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/presupuestos/ItemPresupuesto.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4269713c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/presupuestos/ItemPresupuesto.vue
// module chunks = 0